<template>
  <div class="notice-new">
    <p>{{ notice.created_at | formatDateTime }}</p>
		<div class="notice-table">
			<b-form-group
				id="input-group-1"
				label="件名"
				label-for="input-1">
				<h6>{{ notice.title }}</h6>
			</b-form-group>
			<b-form-group
				id="textarea-rows"
				label="内容"
				label-for="textarea-rows">
				<h6>{{ notice.content }}</h6>
			</b-form-group>
			<p class="notice-detail-btn">
				<b-button @click="noticeEdit">編集</b-button>
				<b-button variant="danger" @click="noticeDelete">消去</b-button>
			</p>
		</div>
  </div>
</template>
<script>
import apiClient from '../../backend'

export default {
  methods: {
  },
  data () {
    return {
			notice: {
				title: '',
				content: '',
				datetime: ''
			}
    }
  },
  components: {
  },
  mounted () {
		apiClient.getNotice({
			id: this.$route.params.id
		}).then(response => {
			this.notice = response
		})
  },
  methods: {
		noticeEdit() {
			this.$router.push({name: 'notice_edit', params: { id: this.$route.params.id }})
		},
		noticeDelete() {
			this.$modal.show('dialog', {
        title: '本当に削除しますか？',
        text: '',
        buttons: [
          {
            title: 'はい',
            handler: () => {
							apiClient.deleteNotice({
								id: this.$route.params.id
							}).then(response => {
								this.$modal.hide('dialog')
								this.$router.go(-1)
							})
            }
          },
          {
            title: 'キャンセル'
          }
        ]
      })
		}
  },
}
</script>
